import { injectable } from "inversify";
import { Either, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import DashboardRepository, { BasicDashboardData } from "../../../domain/repositories/DashboardRepository";
import DashboardRepositoryFake from "./DashboardRepositoryFake";

@injectable()
export default class DashboardRepositoryDev implements DashboardRepository {
    fakeRepository = new DashboardRepositoryFake();
    getBasicData = async (): Promise<Either<ErrorEntity, BasicDashboardData>> => this.fakeRepository.getBasicData();
}